import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useSignupDialog } from "@/contexts/SignupDialogContext";

const Signup = () => {
  const { user } = useAuth();
  const { openSignupDialog } = useSignupDialog();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/feed", { replace: true });
    } else {
      openSignupDialog();
      navigate(-1);
    }
  }, [user, openSignupDialog, navigate]);

  return null;
};

export default Signup;
